module.exports = __webpack_public_path__ + "icon-react-native.uWs0G4HV.svg";